import { render } from "./BackButton.vue?vue&type=template&id=20d902c4&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=20d902c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20d902c4"

export default script